import React from 'react'
import { useDispatch } from 'react-redux'
import { MODAL_KEYS, MY_BILLS_PAGE_TAB_LABEL } from 'app-constants'
import { useHistory } from 'react-router-dom'
import { STATICS } from 'statics'
import { Button } from 'components/button'
import { setModal } from 'slices/modal'
import './style.scss'

export function CreditCardError() {
  const dispatch = useDispatch()
  const history = useHistory()

  function handleBillsClick() {
    history.push(`minhas-faturas#${MY_BILLS_PAGE_TAB_LABEL.BANKSLIPS}`)
    dispatch(setModal({ key: MODAL_KEYS.NONE }))
  }

  return (
    <div className='container-credit-error'>
      <div className='container-icon'>
        <STATICS.CREDIT_WARNING />
      </div>
      <span className='text'>Ocorreu um erro ao gerar o link de pagamento</span>
      <span className='text'>Tente novamente mais tarde ou utilize outro método de pagamento.</span>
      <div className='container-button'>
        <Button onClick={handleBillsClick} color='primary' className='button'>
          Pagar fatura {'>'}
        </Button>
      </div>
    </div>
  )
}
